<template>
  <button
    type="button"
    class="help-btn"
    aria-label="Open tutorial"
    title="Help"
    @click="$emit('triggerTutorial')"
  >
    <span class="help-btn-label">Help?</span>
  </button>
</template>

<style scoped>
.help-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  height: 1.75em;
  padding: 0 0.85em;
  border: none;
  border-radius: 999px;
  background-color: #f4f5f7;
  color: #666666;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.2);
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
}
.help-btn:hover {
  background-color: #eceef1;
  color: #1f2937;
  box-shadow: inset 0 0 0 1px rgba(31, 41, 55, 0.35);
}
.help-btn:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(31, 41, 55, 0.35), 0 0 0 2px rgba(59, 130, 246, 0.4);
}
.help-btn:active {
  transform: translateY(0.5px);
  background-color: #e3e6ea;
}
.help-btn-icon {
  font-size: 0.75em;
}
.help-btn-label {
  letter-spacing: 0.01em;
}
</style>

<script>
export default {
  name: "DT_Tutorial",
  methods: {

  }
}
</script>
